export default {
  "content": "<path d=\"M0 0h48v48H0z\" fill=\"none\"/><path d=\"M46.472 9.118A.995.995 0 0046 9.005V9H2v.005a.985.985 0 00-.472.114A.998.998 0 001 10v28.29A1.717 1.717 0 002.71 40h42.58c.364 0 .73-.12 1.059-.348.017-.011.032-.023.048-.035.383-.301.603-.708.603-1.117V10a1 1 0 00-.528-.882zM24.019 23.449L5.308 11h37.388zm-7.156-2.36L3 36.463V11.867zm1.683 1.12l4.921 3.273a1 1 0 001.107 0l4.922-3.28L43.695 38H4.307zm12.631-1.128L45 11.869v24.597z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};